import React, { Component } from "react";
import PropTypes from "prop-types";
import PropertyInformation from "../Shared/Information/PropertyInformation";
import TenantInformation from "../Shared/Information/TenantInformation";
import Title from "../../Helpers/Title";
import { Button, Grid, CircularProgress, Icon } from "@material-ui/core";
import { connect } from "react-redux";
import { getSingleMatch, setInterested } from "../../../actions/userActions";
import { requestState } from "../../../actions/utils";
import { setInterestRequestState } from "../../../actions/landlordActions";
import LinkHelper from "../../Helpers/Link";

class ProfileMatchInfo extends Component {

    static propTypes = {
        propId: PropTypes.number,
        annoId: PropTypes.number
    }

    constructor( props ) {
        super( props );
        this.setLocalInterested = this.setLocalInterested.bind( this );
        this.props.setInterestRequestState( requestState.none );
        this.state = {
            interestedButtonState: undefined
        }
    }

    setLocalInterested( isInterested ) {
        this.setState({
            interestedButtonState: isInterested
        });
    }

    componentDidMount() {
        if ( this.props.propId ) {
            this.props.getMatch( this.props.annoId, this.props.propId );
        }
    }

    render() {
        const { singleMatch, singleMatchState, announcementLoadState, setInterested } = this.props;
        const backButton = (
            <LinkHelper to="/user/matches">
                <Button
                    color="secondary"
                >
                    <Icon>arrow_back</Icon>&nbsp;Go back to the previous page
                </Button>
            </LinkHelper>
        )
        console.log( "MATCH >>", singleMatch, "MATCH STATE >>", singleMatchState, "ANNOUNCEMENT STATE >>", announcementLoadState ); // DEBUG
        if ( singleMatchState !== requestState.ok || announcementLoadState !== requestState.ok || !singleMatch.tenant ) {
            return (
                <div>
                    {backButton}
                    <br/>
                    <br/>
                    <Grid container justify="center">
                        <CircularProgress/>
                    </Grid>
                </div>
            );
        }
        const profile = singleMatch.tenant.user;
        const property = singleMatch.tenant.properties;
        console.log( "PROFILE >>", profile ); // DEBUG
        console.log( "PROPERTIES >>", property ); // DEBUG
        if ( !profile )
            return (
                <div>
                    {backButton}
                </div>
            )
        const matchInterest = singleMatch.landlordInterestedIn
            ? singleMatch.landlordInterestedIn.some( user => user.id === profile.id )
            : false;
        const isInterested = this.state.interestedButtonState === undefined ? matchInterest : this.state.interestedButtonState;
        return (
            <div className="User-content">
                {backButton}
                <Grid container direction="row" justify="space-between" alignItems="center">
                    <Title title="Match information"/>
                    <div>
                        <Button
                            variant={isInterested ? "contained" : "outlined"}
                            color={isInterested ? "primary" : "secondary"}
                            size="large"
                            onClick={() => {
                                this.setLocalInterested( isInterested ? false : true );
                                setInterested( profile.id, isInterested ? false : true );
                            }}
                        >
                            I'm Interested
                        </Button>
                    </div>
                </Grid>
                <PropertyInformation
                    title="Property the tenant is looking for"
                    properties={property}
                    compare={{
                        ...singleMatch.matches,
                        ...singleMatch.personMatches
                    }}
                />
                <TenantInformation
                    title="Tenant profile"
                    profile={profile}
                    compare={{
                        ...singleMatch.matches,
                        ...singleMatch.personMatches
                    }}
                />
            </div>
        );
    }

}

export default connect(
    state => ({
        singleMatch: state.user.singleMatch,
        singleMatchState: state.user.singleMatchState,
        announcementLoadState: state.landlord.announcementLoadState,
        user: state.user.data,
        interestRequestState: state.landlord.interestRequestState
    }),
    dispatch => ({
        getMatch: ( annoId, propId ) => dispatch( getSingleMatch( annoId, propId ) ),
        setInterested: ( id, interested ) => dispatch( setInterested( id, interested ) ),
        setInterestRequestState: ( state ) => dispatch( setInterestRequestState( state ) )
    })
)( ProfileMatchInfo );